import { debounce } from '@/utils'
export const mixin = {
  methods: {
    logicalHandler (form, isItem) {
      debounce(() => {
        this.getLogicList(form, isItem)
      }, 500, this)()
    },
    getLogicList (form, isItem) {
      let formObj = form || this.form
      let option_id = formObj.q_category === 2 ? formObj.checkboxArr : formObj.q_option_id
      this.$listeners.saveSolo(formObj, formObj.question_id, option_id, isItem)
    }
  }
}
